// src/ProviderConnectionCard.tsx
import { KeyRound } from "lucide-react";
import { jsx, jsxs } from "react/jsx-runtime";
var ProviderConnectionCard = ({ requirement, onConnect }) => {
  const serviceName = (requirement.service_type || "provider").replaceAll("_", " ").replace(/\b\w/g, (letter) => letter.toUpperCase());
  const reconnect = requirement.reason === "auth_expired";
  return /* @__PURE__ */ jsx("div", { className: "my-3 rounded-lg border border-edge-amber-200 bg-fill-hex-fffbeb p-4 text-ink-gray-900 dark:border-edge-amber-800 dark:bg-fill-hex-78350f/20 dark:text-ink-gray-50", children: /* @__PURE__ */ jsxs("div", { className: "flex items-start gap-3", children: [
    /* @__PURE__ */ jsx(KeyRound, { className: "mt-0.5 h-5 w-5 flex-shrink-0 text-ink-hex-d97706 dark:text-ink-amber-400" }),
    /* @__PURE__ */ jsxs("div", { className: "min-w-0 flex-1", children: [
      /* @__PURE__ */ jsxs("p", { className: "text-sm font-semibold", children: [
        serviceName,
        " connection required"
      ] }),
      /* @__PURE__ */ jsxs("p", { className: "mt-1 text-xs text-ink-gray-500 dark:text-ink-gray-300", children: [
        requirement.agent_name || "This agent",
        " needs access to your ",
        serviceName,
        " account."
      ] }),
      /* @__PURE__ */ jsxs(
        "button",
        {
          type: "button",
          onClick: () => onConnect(requirement),
          className: "mt-3 inline-flex items-center gap-1.5 rounded-md bg-fill-primary px-3 py-1.5 text-xs font-medium text-ink-on-primary hover:bg-fill-primary-hover",
          children: [
            /* @__PURE__ */ jsx(KeyRound, { className: "h-3.5 w-3.5" }),
            reconnect ? "Reconnect" : "Connect"
          ]
        }
      )
    ] })
  ] }) });
};
var ProviderConnectionCard_default = ProviderConnectionCard;
export {
  ProviderConnectionCard_default as default
};
